import React from 'react'

import { Checkbox } from '@/components/ui/checkbox'
import { Field } from '@/components/ui/field'
import { Label } from '@/components/ui/label'
import useAppDispatch from '@/hooks/useAppDispatch'
import useAppSelector from '@/hooks/useAppSelector'
import { REFERRAL_CONSENT_STAGE } from '@/lib/constants'
import {
  selectHasConfirmedESignatureUnderstanding,
  selectHasConfirmedRetrospectiveConsentUnderstanding,
  selectHasSubmittedSignature,
  selectIsSignable,
  setHasConfirmedESignatureUnderstanding,
  setHasConfirmedRetrospectiveConsentUnderstanding,
} from '@/redux/slices/referralSignatureConsentPdf'
import { ReferralConsentStage } from '@/types/misc'

interface Props {
  consentStage: ReferralConsentStage
  isSubmittingSignature?: boolean
}

const ESignatureUnderstandingCheckbox: React.FC<Props> = ({
  consentStage,
  isSubmittingSignature = false,
}) => {
  const isSignable = useAppSelector(selectIsSignable)
  const hasSubmittedESignature = useAppSelector(selectHasSubmittedSignature)
  const hasConfirmedRetrospectiveConsentUnderstanding = useAppSelector(
    selectHasConfirmedRetrospectiveConsentUnderstanding,
  )
  const hasConfirmedESignatureUnderstanding = useAppSelector(
    selectHasConfirmedESignatureUnderstanding,
  )
  const dispatch = useAppDispatch()

  function toggleRetrospectiveConsentUnderstandingCheckbox() {
    dispatch(
      setHasConfirmedRetrospectiveConsentUnderstanding(
        !hasConfirmedRetrospectiveConsentUnderstanding,
      ),
    )
  }

  function toggleESignatureUnderstandingCheckbox() {
    dispatch(
      setHasConfirmedESignatureUnderstanding(
        !hasConfirmedESignatureUnderstanding,
      ),
    )
  }

  const isDisabled =
    !isSignable || hasSubmittedESignature || isSubmittingSignature

  return (
    <div className="flex flex-col gap-1.5">
      {consentStage === REFERRAL_CONSENT_STAGE.RETROSPECTIVE && (
        <Field orientation="horizontal" className="items-start gap-x-1.5">
          <Checkbox
            disabled={isDisabled}
            checked={hasConfirmedRetrospectiveConsentUnderstanding}
            onCheckedChange={() =>
              toggleRetrospectiveConsentUnderstandingCheckbox()
            }
            id="confirmRetrospectiveUnderstanding"
          />

          <Label htmlFor="confirmRetrospectiveUnderstanding">
            I confirm that I have read and understood the above and consent to
            the arrangements described.
          </Label>
        </Field>
      )}

      <Field orientation="horizontal" className="items-start gap-x-1.5">
        <Checkbox
          disabled={isDisabled}
          checked={hasConfirmedESignatureUnderstanding}
          onCheckedChange={() => toggleESignatureUnderstandingCheckbox()}
          id="agreeToESignatureValidity"
        />

        <Label htmlFor="agreeToESignatureValidity">
          I agree that my electronic signature is as valid and legally binding
          as a handwritten signature.
        </Label>
      </Field>
    </div>
  )
}
export default ESignatureUnderstandingCheckbox
